export default __webpack_public_path__ + "static/media/user.5be1c68a.svg";